/* eslint-disable no-case-declarations */
import moment, { Moment } from 'moment';
import { findStop, poiToAddress } from '../../../utils/business';
import {
    Address,
    Quote,
    Stop,
    StopType,
    AutoCompleteAddress,
    BaseUser,
    Ride,
    POI,
    MeetingPoint,
    PaymentCard,
    Location,
    CostCenter,
    Policy,
    UserSettings,
    CreateRideInput,
    Voucher,
} from '../../apiTypes';

import { getUser } from '../../../localStorageAPI';
import { getDefaultGroup, isContractPerso } from '../../../utils/user';
import { types as userTypes } from '../user';
import { types as policyTypes } from '../currentPolicy';
import { RESET_VALUE } from '../../../components/profile/editSelect';
import { addTimeToDate, convertToServerTimeZone, unix } from '../../../utils/date';
import { RETURN_TRIP_HOURS_DELAY } from '../../../utils/constants';

// Module Name
export const name = 'currentBooking';

// ActionTypes
export const types = {
    SET_PICKUP: `${name}/SET_PICKUP`,
    SET_DROP_OFF: `${name}/SET_DROP_OFF`,
    DELETE_PICKUP: `${name}/DELETE_PICKUP`,
    DELETE_DROP_OFF: `${name}/DELETE_DROP_OFF`,

    SET_POI: `${name}/SET_POI`,
    SET_POI_DROP_OFF: `${name}/SET_POI_DROP_OFF`,
    SET_POI_AS_ADDRESS: `${name}/SET_POI_AS_ADDRESS`,
    SET_POI_NUMBER: `${name}/SET_POI_NUMBER`,
    SET_POI_MEETING_POINT: `${name}/SET_POI_MEETING_POINT`,
    SET_POI_PANCARTE: `${name}/SET_POI_PANCARTE`,

    SET_QUOTE: `${name}/SET_SERVICE`,
    SET_SELECTED_SERVICE: `${name}/SET_SELECTED_SERVICE`,
    SET_NOTE: `${name}/SET_NOTE`,
    SET_RIDE_REASON: `${name}/SET_RIDE_REASON`,
    SET_GROUP_ID: `${name}/SET_GROUP_ID`,
    SET_PROVISION: `${name}/SET_PROVISION`,
    SET_PAYMENT: `${name}/SET_PAYMENT`,
    SET_COST_CENTER: `${name}/SET_COST_CENTER`,
    SET_PASSENGERS: `${name}/SET_PASSENGERS`,
    SET_RESERVATION_DATE: `${name}/SET_RESERVATION_DATE`,
    SET_TRACKED_RIDE: `${name}/SET_TRACKED_RIDE`,
    SEARCH_LOCATION_CLOSEST: `${name}/SEARCH_LOCATION_CLOSEST`,
    SET_AUTO_CONFIRM: `${name}/SET_AUTO_CONFIRM`,
    SET_AUTO_PREFILL: `${name}/SET_AUTO_PREFILL`,
    SET_RIDE: `${name}/SET_RIDE`,
    SET_VOUCHER: `${name}/SET_VOUCHER`,
    SET_VOUCHER_AMOUNT: `${name}/SET_VOUCHER_AMOUNT`,
    SET_CURRENT_POSITION: `${name}/SET_CURRENT_POSITION`,
    SET_IS_EDITING: `${name}/SET_IS_EDITING`,
    RESET_ALL: `${name}/RESET_ALL`,
    RESET_POI_DATA: `${name}/RESET_POI_DATA`,
    RETURN_TRIP: `${name}/RETURN_TRIP`,
    PREFILL_RIDE: `${name}/PREFILL_RIDE`,
    SET_WAYPOINTS: `${name}/SET_WAYPOINTS`,
    SET_SHOULD_AVOID_POI: `${name}/SET_SHOULD_AVOID_POI`,
    SET_CAN_SKIP_POI: `${name}/SET_CAN_SKIP_POI`,
    RESET_WAYPOINTS: `${name}/RESET_WAYPOINTS`,
    SAVE_LASTRIDE: `${name}/SAVE_LASTRIDE`,
    SET_CURRENT_ETA_QUOTE: `${name}/SET_CURRENT_ETA_QUOTE`,
    SET_RECURRENCE: `${name}/SET_RECURRENCE`,
};

export interface CurrentBookingState {
    stops: Stop[];
    poi: POI;
    poiNumber: string;
    poiMeetingPoint: MeetingPoint;
    poiPancarte: boolean;
    quote: Quote;
    selectedService: string;
    note: string;
    rideReason: string;
    voucher: Voucher;
    voucherAmount: string;
    groupId: string;
    provision: string;
    payment: PaymentCard;
    costCenter: CostCenter;
    passengers: BaseUser[];
    date: Date;
    trackedRide: Ride;
    autoConfirm: boolean;
    autoPrefill: boolean;
    ride: Ride;
    currentPosition: Location;
    isEditing: boolean;
    shouldAvoidPoi: boolean;
    canSkipPoi: boolean;
    waypoints: Location[];
    lastRide: Omit<CurrentBookingState, 'lastRide'>;
    recurrence: number[];
}

// InitialState
export const initialState: CurrentBookingState = {
    stops: [],
    poi: null,
    // poi: {
    //     id: 1,
    //     name: 'Orly Airport',
    //     force_selection: true,
    //     address: {
    //         name: 'Aéroport Paris-Orly, A106, 94390 Paray-Vieille-Poste, France',
    //         location: { lat: 48.72814, lng: 2.36876 },
    //         type: AddressType.AIRPORT,
    //         details: {
    //             street_number: '',
    //             full_name: 'Aéroport Paris-Orly, A106, 94390 Paray-Vieille-Poste, France',
    //             street: 'Aéroport Paris-Orly, A106, 94390 Paray-Vieille-Poste, France',
    //             zip_code: '94390',
    //             city: 'Paray-Vieille-Poste',
    //             country: 'France',
    //         },
    //     },
    //     meeting_points: [
    //         {
    //             name: 'South',
    //             id: 1,
    //             rdv_point: 'Your meeting point is Arrivals level, Door D',
    //             type: MeetingPointType.TERMINAL,
    //             location: {
    //                 lat: 48.7280555,
    //                 lng: 2.3691834,
    //             },
    //         },
    //         {
    //             name: 'West',
    //             id: 2,
    //             rdv_point: 'Your meeting point is Arrivals level, Door D',
    //             type: MeetingPointType.TERMINAL,
    //             location: {
    //                 lat: 48.7287236,
    //                 lng: 2.3589962,
    //             },
    //         },
    //     ],
    //     area: {
    //         type: 'circle',
    //         radius: 2500,
    //         center: {
    //             lat: 48.729983,
    //             lng: 2.366095,
    //         },
    //     },
    //     type: AddressType.AIRPORT,
    // },
    poiNumber: '',
    poiMeetingPoint: null,
    poiPancarte: false,
    quote: null,
    selectedService: '',
    note: '',
    rideReason: '',
    voucher: null,
    voucherAmount: '',
    groupId: '',
    provision: '',
    payment: null,
    costCenter: null,
    passengers: [],
    date: null,
    trackedRide: null,
    autoConfirm: true,
    autoPrefill: true,
    ride: null,
    currentPosition: null,
    isEditing: false,
    shouldAvoidPoi: false,
    canSkipPoi: true,
    waypoints: [],
    lastRide: null,
    recurrence: [],
};

// Reducer
export default (state = initialState, action: any = {}): CurrentBookingState => {
    let newState;
    const { lastRide, ...currentState } = state;
    const { policy }: { policy: Policy } = action?.payload || {};

    switch (action.type) {
        case types.SET_PICKUP:
            newState = addOrdEditStop(state, action, StopType.PICKUP);
            return {
                ...newState,
                poi: action.payload?.address?.poi || null,
            };
        case types.SET_DROP_OFF:
            newState = addOrdEditStop(state, action, StopType.DROP_OFF);
            // We reset the free ride provision (0) if we add a drop off
            if (state.provision === String(0)) {
                newState.provision = '';
            }
            return newState;
        case types.SET_POI: {
            // const { poi } = action.payload;
            // // TODO: use POI address when available
            // const poiAddress: Address = poiToAddress(poi);
            // newState = addOrdEditStop(state, { payload: { address: poiAddress } }, StopType.PICKUP);
            return {
                ...state,
                poi: action.payload.poi,
                shouldAvoidPoi: false,
                canSkipPoi: true,
            };
        }
        case types.SET_POI_DROP_OFF: {
            const { poi } = action.payload;
            // TODO: use POI address when available
            const poiAddress: Address = poiToAddress(poi);
            newState = addOrdEditStop(state, { payload: { address: poiAddress } }, StopType.DROP_OFF);
            return {
                ...newState,
            };
        }
        case types.SET_POI_AS_ADDRESS: {
            const { stopType } = action.payload;
            const poiAddress: Address = poiToAddress(state.poi);
            newState = addOrdEditStop(state, { payload: { address: poiAddress } }, stopType);
            return {
                ...newState,
            };
        }
        case types.SET_POI_NUMBER:
            return {
                ...state,
                poiNumber: action.payload.number,
            };
        case types.SET_POI_MEETING_POINT:
            return {
                ...state,
                poiMeetingPoint: action.payload.meetingPoint,
            };
        case types.SET_POI_PANCARTE:
            return {
                ...state,
                poiPancarte: action.payload.pancarte,
            };
        case types.DELETE_PICKUP:
            return {
                ...state,
                stops: state.stops.filter((stop: Stop) => stop.stop_type !== StopType.PICKUP),
                poi: null,
                poiNumber: '',
                poiMeetingPoint: null,
            };
        case types.DELETE_DROP_OFF:
            return {
                ...state,
                stops: state.stops.filter((stop: Stop) => stop.stop_type !== StopType.DROP_OFF),
            };
        case types.SET_QUOTE:
            return {
                ...state,
                quote: action.payload.quote,
                ...(action.payload.quote ? { selectedService: action.payload.quote.service.name } : {}),
            };
        case types.SET_CURRENT_ETA_QUOTE:
            return {
                ...state,
                quote: { ...state.quote, estimate_eta: action.payload.estimate_eta },
            };
        case types.SET_SELECTED_SERVICE:
            return {
                ...state,
                selectedService: action.payload.selectedService,
            };
        case types.SET_NOTE:
            return {
                ...state,
                note: action.payload.note,
            };
        case types.SET_RIDE_REASON:
            return {
                ...state,
                rideReason: action.payload.rideReason,
            };
        case types.SET_GROUP_ID:
            return {
                ...state,
                groupId: action.payload.groupId,
                autoPrefill: true,
            };
        case types.SET_PAYMENT:
            return {
                ...state,
                payment: action.payload.payment,
            };
        case types.SET_COST_CENTER:
            return {
                ...state,
                costCenter: action.payload.costCenter,
            };
        case policyTypes.SET_CURRENT_POLICY:
            if (policy?.default_cost_center_mode === 'per_group' && policy?.cost_centers) {
                const noDefaultCostCenter = policy.no_default_cost_center;
                let defaultCostCenter = !noDefaultCostCenter ? policy.cost_centers?.find((cc) => cc.is_default) : null;
                if (!noDefaultCostCenter && policy.cost_center_mandatory && !defaultCostCenter) {
                    // If no default cost center is set, we take the first one only if there is only one cost center in the list
                    if (policy?.cost_centers?.length === 1) {
                        defaultCostCenter = policy.cost_centers[0];
                    }
                }
                return {
                    ...state,
                    costCenter: defaultCostCenter ?? null,
                };
            }
            return state;
        case policyTypes.SET_CURRENT_USER_POLICY:
            const { userPolicy, groupId }: { userPolicy: Policy; groupId: string } = action.payload;
            const defaultSettings: UserSettings = userPolicy?.default_settings as UserSettings;
            const noDefaultCostCenter = policy.no_default_cost_center;
            const isCostCenterPerUser = !noDefaultCostCenter && policy?.default_cost_center_mode === 'per_user';
            if (isCostCenterPerUser && defaultSettings?.default_cost_centers?.length) {
                const defaultCostCenterData = defaultSettings?.default_cost_centers?.find(
                    (cc) => cc.group_id === groupId,
                );
                const defaultCostCenter = defaultCostCenterData?.cost_center ?? policy?.cost_centers?.[0];
                return {
                    ...state,
                    costCenter: defaultCostCenter ?? null,
                };
            }
            return {
                ...state,
                ...(isCostCenterPerUser && {
                    costCenter: policy?.cost_centers?.[0] ?? null,
                }),
            };
        case types.SET_PROVISION:
            return {
                ...state,
                provision: action.payload.provision,
            };
        case types.SET_PASSENGERS:
            return {
                ...state,
                passengers: [...action.payload.passengers],
            };
        case userTypes.CHANGE_LANGUAGE:
            if (!state.date) {
                return state;
            }
            moment.locale(action.payload.lang);
            return {
                ...state,
                date: convertToServerTimeZone(unix((state.date as unknown as Moment).unix())) as unknown as Date,
            };
        case types.SET_RESERVATION_DATE:
            return {
                ...state,
                date: action.payload.date,
            };
        case types.SET_TRACKED_RIDE:
            return {
                ...state,
                trackedRide: action.payload.trackedRide,
            };
        case types.SET_AUTO_CONFIRM:
            return {
                ...state,
                autoConfirm: action.payload.autoConfirm,
            };
        case types.SET_AUTO_PREFILL:
            return {
                ...state,
                autoPrefill: action.payload.autoPrefill,
            };
        case types.SET_RIDE:
            return {
                ...state,
                ride: action.payload.ride,
            };
        case types.SET_VOUCHER:
            return {
                ...state,
                voucher: action.payload.voucher,
            };
        case types.SET_VOUCHER_AMOUNT:
            return {
                ...state,
                voucherAmount: action.payload.voucherAmount,
            };
        case types.SET_CURRENT_POSITION:
            return {
                ...state,
                currentPosition: action.payload.currentPosition,
            };
        case types.SET_IS_EDITING:
            return {
                ...state,
                isEditing: action.payload.isEditing,
            };
        case types.SET_SHOULD_AVOID_POI:
            return {
                ...state,
                shouldAvoidPoi: action.payload.value,
            };
        case types.SET_CAN_SKIP_POI:
            return {
                ...state,
                canSkipPoi: action.payload.value,
            };
        case types.SET_RECURRENCE:
            return {
                ...state,
                recurrence: action.payload.recurrence,
            };
        case types.RESET_ALL: {
            const user = getUser();
            return {
                ...initialState,
                costCenter: state.costCenter ?? null,
                groupId: state.groupId ?? getDefaultGroup()?.uuid,
                passengers: [
                    {
                        firstname: user.firstname,
                        lastname: user.lastname,
                        phone_number: user.phones[0]?.phone,
                        id: user.id,
                    },
                ],
                payment: state.payment ?? null,
            };
        }
        case types.RESET_POI_DATA:
            return {
                ...state,
                poi: null,
                poiNumber: '',
                poiMeetingPoint: null,
                poiPancarte: false,
                shouldAvoidPoi: false,
                canSkipPoi: true,
                groupId: state.groupId ?? getDefaultGroup()?.uuid,
            };
        case types.SET_WAYPOINTS:
            return { ...state, waypoints: action.payload.waypoints };
        case types.RESET_WAYPOINTS:
            return { ...state, waypoints: [] };
        case types.RETURN_TRIP: {
            const base = state.stops.length ? state : state.lastRide;
            const revertedStops = reverseStops(base.stops);
            return {
                ...initialState,
                stops: revertedStops,
                poi: revertedStops[0]?.address?.poi || null,
                autoConfirm: false,
                autoPrefill: false,
                costCenter: base.costCenter ?? null,
                groupId: base.groupId ?? getDefaultGroup()?.uuid,
                passengers: base.passengers ?? [],
                payment: base.payment ?? null,
                date: addTimeToDate(RETURN_TRIP_HOURS_DELAY, base.date as unknown as Moment, 'h'),
            };
        }
        case types.PREFILL_RIDE:
            return prefillRide(
                state,
                action.payload.ride,
                action.payload.paymentList,
            ) as unknown as CurrentBookingState;
        case types.SAVE_LASTRIDE:
            return {
                ...initialState,
                costCenter: state.costCenter ?? null,
                groupId: state.groupId ?? getDefaultGroup()?.uuid,
                passengers: state.passengers ?? [],
                payment: state.payment ?? null,
                lastRide: currentState,
            };

        default:
            return state;
    }
};

// ActionCreators
export const actions = {
    setPickupAddress: (address: Address): any => ({ type: types.SET_PICKUP, payload: { address } }),
    setDropOffAddress: (address: Address): any => ({ type: types.SET_DROP_OFF, payload: { address } }),
    setPOI: (poi: POI): any => ({ type: types.SET_POI, payload: { poi } }),
    setPOIDropOff: (poi: POI): any => ({ type: types.SET_POI_DROP_OFF, payload: { poi } }),
    setPOIAsAddress: (stopType: StopType): any => ({ type: types.SET_POI_AS_ADDRESS, payload: { stopType } }),
    setPOINumber: (number: string): any => ({ type: types.SET_POI_NUMBER, payload: { number } }),
    setPOIMeetingPoint: (meetingPoint: MeetingPoint): any => ({
        type: types.SET_POI_MEETING_POINT,
        payload: { meetingPoint },
    }),
    setPOIPancarte: (pancarte: boolean): any => ({ type: types.SET_POI_PANCARTE, payload: { pancarte } }),
    deletePickup: (): any => ({ type: types.DELETE_PICKUP }),
    deleteDropOff: (): any => ({ type: types.DELETE_DROP_OFF }),
    setQuote: (quote: Quote): any => ({ type: types.SET_QUOTE, payload: { quote } }),
    setSelectedService: (selectedService: string): any => ({
        type: types.SET_SELECTED_SERVICE,
        payload: { selectedService },
    }),
    setNote: (note: string): any => ({ type: types.SET_NOTE, payload: { note } }),
    setRideReason: (rideReason: string): any => ({ type: types.SET_RIDE_REASON, payload: { rideReason } }),
    setVoucher: (voucher: Voucher): any => ({ type: types.SET_VOUCHER, payload: { voucher } }),
    setVoucherAmount: (voucherAmount: string): any => ({ type: types.SET_VOUCHER_AMOUNT, payload: { voucherAmount } }),
    setGroupId: (groupId: string): any => ({ type: types.SET_GROUP_ID, payload: { groupId } }),
    setProvision: (provision: string): any => ({ type: types.SET_PROVISION, payload: { provision } }),
    setPayment: (payment: PaymentCard): any => ({ type: types.SET_PAYMENT, payload: { payment } }),
    setCostCenter: (costCenter: CostCenter): any => ({ type: types.SET_COST_CENTER, payload: { costCenter } }),
    setPassengers: (passengers: BaseUser[]): any => ({ type: types.SET_PASSENGERS, payload: { passengers } }),
    setReservationDate: (date: any): any => ({ type: types.SET_RESERVATION_DATE, payload: { date } }),
    setTrackedRide: (trackedRide: Ride): any => ({ type: types.SET_TRACKED_RIDE, payload: { trackedRide } }),
    searchClosestLocation: (address: AutoCompleteAddress, stopType: StopType, onError?: (e?: any) => void): any => ({
        type: types.SEARCH_LOCATION_CLOSEST,
        payload: { address, stopType },
        onError: (e) => {
            onError?.(e);
        },
    }),
    setAutoConfirm: (autoConfirm: boolean): any => ({ type: types.SET_AUTO_CONFIRM, payload: { autoConfirm } }),
    setAutoPrefill: (autoPrefill: boolean): any => ({ type: types.SET_AUTO_PREFILL, payload: { autoPrefill } }),
    setRide: (ride: Ride): any => ({ type: types.SET_RIDE, payload: { ride } }),
    setCurrentPosition: (currentPosition: Location): any => ({
        type: types.SET_CURRENT_POSITION,
        payload: { currentPosition },
    }),
    setIsEditing: (isEditing: boolean): any => ({
        type: types.SET_IS_EDITING,
        payload: { isEditing },
    }),
    setShouldAvoidPoi: (value: boolean): any => ({
        type: types.SET_SHOULD_AVOID_POI,
        payload: { value },
    }),
    setCanSkipPoi: (value: boolean): any => ({
        type: types.SET_CAN_SKIP_POI,
        payload: { value },
    }),
    resetAll: (): any => ({ type: types.RESET_ALL }),
    resetPoiData: (): any => ({ type: types.RESET_POI_DATA }),
    saveLastRide: (): any => ({ type: types.SAVE_LASTRIDE }),
    returnTrip: (): any => ({ type: types.RETURN_TRIP }),
    prefillRide: (ride: Ride, paymentList: PaymentCard[]): any => ({
        type: types.PREFILL_RIDE,
        payload: { ride, paymentList },
    }),
    setWaypoints: (waypoints: Location[]): any => ({ type: types.SET_WAYPOINTS, payload: { waypoints } }),
    resetWaypoints: (): any => ({ type: types.RESET_WAYPOINTS }),
    setQuoteEta: (quoteEta: number): any => ({
        type: types.SET_CURRENT_ETA_QUOTE,
        payload: { estimate_eta: quoteEta },
    }),
    setRecurrence: (recurrence: number[]): any => ({
        type: types.SET_RECURRENCE,
        payload: { recurrence },
    }),
};

// Selectors
const localState = (state: any): CurrentBookingState => state[name] || initialState;
export const selectors = {
    currentBookingStops: (state: any): Stop[] => localState(state).stops,
    currentBookingPOI: (state: any): POI => localState(state).poi,
    currentBookingPOINumber: (state: any): string => localState(state).poiNumber,
    currentBookingPOIMeetingPoint: (state: any): MeetingPoint => localState(state).poiMeetingPoint,
    currentBookingPOIPancarte: (state: any): boolean => localState(state).poiPancarte,
    currentBookingNote: (state: any): string => localState(state).note,
    currentBookingRideReason: (state: any): string => localState(state).rideReason,
    currentBookingVoucher: (state: any): Voucher => localState(state).voucher,
    currentBookingVoucherAmount: (state: any): string => localState(state).voucherAmount,
    currentBookingQuote: (state: any): Quote => localState(state).quote,
    currentSelectedService: (state: any): string => localState(state).selectedService,
    currentReservationDate: (state: any): any => localState(state).date,
    currentTrackedRide: (state: any): any => localState(state).trackedRide,
    currentBookingPassengers: (state: any): BaseUser[] => localState(state).passengers,
    currentBookingPayment: (state: any): PaymentCard => localState(state).payment,
    currentBookingCostCenter: (state: any): CostCenter => localState(state).costCenter,
    currentBookingProvision: (state: any): string => localState(state).provision,
    currentPosition: (state: any): Location => localState(state).currentPosition,
    recurrence: (state: any): number[] => localState(state).recurrence,
    groupId: (state: any): string => localState(state).groupId,
    autoConfirm: (state: any): boolean => localState(state).autoConfirm,
    autoPrefill: (state: any): boolean => localState(state).autoPrefill,
    isEditing: (state: any): boolean => localState(state).isEditing,
    ride: (state: any): Ride => localState(state).ride || localState(state).lastRide?.ride,
    lastRide: (state: any): Ride => localState(state).lastRide?.ride,
    // Le devis commandé, comme `ride` : la page de confirmation appelle saveLastRide au montage,
    // ce qui remet le booking à zéro et déplace le devis dans lastRide.
    bookedQuote: (state: any): Quote => localState(state).quote || localState(state).lastRide?.quote,
    waypoints: (state: any): Location[] => localState(state).waypoints,
    shouldAvoidPoi: (state: any): boolean => localState(state).shouldAvoidPoi,
    canSkipPoi: (state: any): boolean => localState(state).canSkipPoi,
    generateRidePayload: (state: any, withPoi = false): CreateRideInput =>
        generateRidePayload(localState(state), withPoi),
};

function addOrdEditStop(state: CurrentBookingState, action: any, stopType: StopType) {
    const findStopIndex: number = state.stops.findIndex((stop: Stop) => stop.stop_type === stopType);
    if (!action.payload.address) {
        return {
            ...state,
            stops: state.stops.filter((stop: Stop) => stop.stop_type !== stopType),
        };
    }
    if (findStopIndex >= 0) {
        const newStops: Stop[] = [...state.stops];
        const updatedStop = { ...newStops[findStopIndex] };
        updatedStop.address = { ...action.payload.address };

        if (updatedStop.address?.poi) {
            updatedStop.address = {
                ...updatedStop.address,
                type: updatedStop.address.poi.type,
            };
        }

        newStops[findStopIndex] = updatedStop;

        return {
            ...state,
            stops: newStops,
        };
    }

    return {
        ...state,
        stops: [
            ...state.stops,
            {
                address: {
                    ...action.payload.address,
                    ...(action.payload.address.poi && { type: action.payload.address.poi.type }),
                },
                stop_type: stopType,
            },
        ],
    };
}

function reverseStops(stops: Stop[]) {
    const pickupIndex: number = stops.findIndex((stop: Stop) => stop.stop_type === StopType.PICKUP);
    const dropoffIndex: number = stops.findIndex((stop: Stop) => stop.stop_type === StopType.DROP_OFF);
    if (pickupIndex >= 0 && dropoffIndex >= 0) {
        const newStops: Stop[] = [...stops];
        const tmp = newStops[pickupIndex].address;
        newStops[pickupIndex].address = newStops[dropoffIndex].address;
        newStops[dropoffIndex].address = tmp;
        return newStops;
    }
    return stops;
}

function prefillRide(state: CurrentBookingState, ride: Ride, paymentList: PaymentCard[]) {
    const pickup = findStop(ride.stops, StopType.PICKUP);
    return {
        ...initialState,
        stops: ride.stops
            .filter((s) => s.stop_order !== -1)
            .map(({ address, stop_type, stop_order }) => ({ address, stop_type, stop_order })), // filter fake stop: -1 and remove additional infos
        note: ride.driver_note,
        rideReason: ride.ride_reason,
        date: ride.start_date ? convertToServerTimeZone(unix(+ride.start_date)) : null,
        passengers: ride.riders,
        payment: paymentList.find((el) => el?.id === ride?.payment_method?.id),
        ...(((ride.provision === 0 && ride.is_free_ride) || ride.provision > 0) && { provision: `${ride.provision}` }),
        poi: (pickup?.address as any)?.poi_id ? pickup?.address : null,
        poiNumber: pickup.connection_details?.number || null,
        poiPancarte: ride.nameboard_option,
        costCenter: ride.cost_center,
        poiMeetingPoint:
            (ride.nameboard_option
                ? pickup.address?.meeting_points_nameBoard?.find(
                      (meetingPoint: MeetingPoint) => String(meetingPoint.id) === String(pickup.meeting_point_id),
                  )
                : pickup.address?.meeting_points?.find(
                      (meetingPoint: MeetingPoint) => String(meetingPoint.id) === String(pickup.meeting_point_id),
                  )) ?? null,
        groupId: ride?.group?.uuid ? ride.group.uuid : state.groupId,
        autoConfirm: false,
        autoPrefill: false,
        quote: ride.service,
        selectedService: ride.service.name,
        ride,
    };
}

function generateRidePayload(state: CurrentBookingState, withPoi: boolean): CreateRideInput {
    const {
        quote,
        note,
        poiNumber,
        rideReason,
        groupId,
        costCenter,
        passengers,
        payment,
        poiMeetingPoint,
        poiPancarte,
        isEditing,
        voucher,
        voucherAmount,
        ride,
        date,
    } = state;
    const isPerso = isContractPerso(groupId);
    const isAsap = !date;
    const hasMeetingPoint = poiMeetingPoint?.id;
    const payload: CreateRideInput = {
        quote_id: quote?.id,
        ...(note && { driver_note: note }),
        ...(!isPerso && rideReason && { ride_reason: rideReason }),
        ...(!isPerso && costCenter && costCenter.id !== RESET_VALUE && { cost_center_id: costCenter.id }),
        ...(withPoi && { meeting_point_id: poiMeetingPoint?.id }),
        ...(!isAsap &&
            withPoi &&
            hasMeetingPoint &&
            (poiPancarte || (isEditing && ride?.id && ride.nameboard_option !== poiPancarte)) && {
                nameboard_option: poiPancarte,
            }),
        ...(!isAsap && poiNumber && { connection_number: poiNumber }),
        ...(quote?.is_assistance && voucher && { voucher_id: voucher.id, onboard_payment: true }),
        ...(quote?.is_assistance && voucherAmount && { voucher_amount: +voucherAmount, onboard_payment: true }),
        payment_method_id:
            passengers[0]?.id === getUser().id || passengers[0]?.user_type === 'guest' ? payment?.id : undefined,
        riders: passengers,
        booking_platform: 'WEB_APP',
    };
    return payload;
}
